import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map, of } from "rxjs";
import { AssignmentService } from "src/app/assignment/services/assignment.service";
import { IBaseSearchRequest } from "src/app/core/models/base";

export function AssignmentInternalNumberValidator(assignmentService: AssignmentService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'internalNumber',
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }
        if(!control.pristine){
            return assignmentService.searchAssignments(request)
                .pipe(
                    map(response => {
                        const assignments = response.data;

                        return assignments.length != 0 ? {internalNumberExists: true} : null;
                    })
                )
        }
        else {
            return of(null);
        }
    }
}
